import { makeStyles } from '@material-ui/styles';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginRight: '0.25em',
  },
});

const MultiplierHeader = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <span className={classes.title}>
        {t('multiplierMatrix.tableHeader.multiplier')}
      </span>
      <InfoWithTooltip
        title={t('multiplierMatrix.tableHeader.multiplier.tooltip')}
        link={EXTERNAL_URLS.individualMultiplier}
      />
    </div>
  );
};

export default MultiplierHeader;
